import { Link } from "@/components/site/LocaleLink";
import { ArrowRight, Quote } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { IMG } from "@/data/images";
import { Picture } from "@/components/site/Picture";
import { Reveal } from "@/components/site/Reveal";

export const AboutStory = () => {
  const { t } = useLang();
  return (
    <section className="bg-cream py-24 lg:py-32" data-testid="about-story">
      <div className="container-x grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
        <Reveal className="relative">
          <div className="relative overflow-hidden rounded-2xl">
            <Picture
              img={IMG.healthyFlock}
              alt="Healthy broiler flock in a modern poultry house"
              className="aspect-[4/5] w-full object-cover"
              sizes="(min-width: 1024px) 50vw, 100vw"
            />
          </div>
          <div className="absolute -bottom-6 end-6 max-w-[280px] rounded-xl border border-line bg-white p-6 shadow-[0_20px_50px_rgba(24,58,55,0.1)] lg:-end-6">
            <Quote className="h-7 w-7 text-gold rtl-flip" />
            <p className="mt-3 font-display text-base font-semibold leading-snug text-forest">{t.about.quote}</p>
            <p className="mt-3 text-xs text-stone">— {t.about.quoteBy}</p>
          </div>
        </Reveal>

        <div className="lg:ps-4">
          <Reveal>
            <p className="eyebrow mb-4 text-gold-ink">{t.about.kicker}</p>
          </Reveal>
          <Reveal i={1}>
            <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight text-forest sm:text-4xl lg:text-[2.75rem]">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal i={2}>
            <p className="mt-6 text-base leading-relaxed text-stone sm:text-lg">{t.about.p1}</p>
          </Reveal>
          <Reveal i={3}>
            <p className="mt-4 text-base leading-relaxed text-stone sm:text-lg">{t.about.p2}</p>
          </Reveal>
          <Reveal i={4}>
            <Link
              to="/about"
              data-testid="about-story-cta"
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-forest px-6 py-3 text-sm font-semibold text-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-forest-dark"
            >
              {t.about.cta}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 rtl-flip" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
